import { fillFormDemoFromUpload } from '@/pages/api/scribeAPIV2';
import { type FillFormDemoFromUploadRequest, type FillFormDemoResponse } from '@/types';
import { useMutation } from '@tanstack/react-query';

export const DEMO_FILL_FORM_FROM_UPLOAD_MUTATION_KEY = [
  'demo-fill-form-from-upload',
] as const;

export function useMutateFillFormDemoFromUpload() {
  return useMutation<FillFormDemoResponse, Error, FillFormDemoFromUploadRequest>({
    mutationKey: DEMO_FILL_FORM_FROM_UPLOAD_MUTATION_KEY,
    gcTime: 0,
    mutationFn: async (request) => {
      const { data } = await fillFormDemoFromUpload(request);
      return data;
    },
  });
}
